import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  level: 1,
  hasSeenIntroduction: false,
  correctItemsCount: 0,
};

const roundReducer = (state = initialState, { gameId, type, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.START_LEVEL:
      return {
        ...state,
        level: payload,
        correctItemsCount: 0,
      };

    case REDUX_ACTIONS.INCREMENT_CORRECT_ITEM_COUNT: {
      const { correctItemsCount } = state;

      return {
        ...state,
        correctItemsCount: correctItemsCount + 1,
      };
    }

    case REDUX_ACTIONS.MARK_INTRO_AS_SEEN: {
      return {
        ...state,
        hasSeenIntroduction: true,
      };
    }

    default:
      return state;
  }
};

export default roundReducer;
